// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "increase-2Abm8";
var _4 = "decrease-2jHCS";
var _5 = "type-2GZCi";
var _6 = "passenger-M8RzZ";
var _7 = "counter-3BKKi";
var _8 = "passenger__headerServices-1nqUc";
var _9 = "info-3k4s9";
var _a = "description-ehXBd";
export { _1 as "__esModule", _2 as "mobile", _3 as "increase", _4 as "decrease", _5 as "type", _6 as "passenger", _7 as "counter", _8 as "passenger__headerServices", _9 as "info", _a as "description" }
export default { "__esModule": _1, "mobile": _2, "increase": _3, "decrease": _4, "type": _5, "passenger": _6, "counter": _7, "passenger__headerServices": _8, "info": _9, "description": _a }
